import { MessageOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";
import React, { useState } from "react";
import FeedbackModal from "./FeedbackModal";

const FloatingFeedback: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FloatButton
        icon={<MessageOutlined />}
        type="primary"
        tooltip="意见反馈"
        style={{ right: 24, bottom: 24 }}
        onClick={() => setOpen(true)}
      />
      <FeedbackModal open={open} onCancel={() => setOpen(false)} />
    </>
  );
};

export default FloatingFeedback;
